import classNames from 'classnames';
import React from 'react';

import { Stamp } from '@zooplus/icons';

import { ThemedIcon } from '../Icon/Icon';

import styles from './CategoryFlyout.module.scss';

const ICON_SIZE = 20;

export const SpecialIcon = ({
    spaced,
    className,
}: {
    spaced?: boolean;
    className?: string;
}): React.JSX.Element => {
    const spacing = spaced ? styles.specialIconSpaced : undefined;

    return (
        <span
            data-zta="special-icon"
            className={classNames(
                styles.specialIconFilled,
                spacing,
                className,
            )}>
            <ThemedIcon
                className={styles.specialIconSvg}
                color="neutralDark"
                aligned
                size={ICON_SIZE}
                Icon={Stamp}
                aria-hidden="true"
            />
        </span>
    );
};

export default SpecialIcon;
